import { ReactElement, useContext, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { LayoutContext } from 'components/v2/Content'
import FormLayoutV2 from 'components/v2/FormLayout'
import Heading from 'components/v2/Heading'
import { SummaryForm } from 'features/Routes/components/EditRoute/SummaryForm'
import { IChangeRouteServiceRouteForm } from 'features/Routes/components/EditRoute/RouteForm/types'
import { IService } from 'features/Services/components/NewServicesV2/components/ServicesForm/types'
import { getEmptyItinerary, mapItineraryScheduleToItinerary } from 'models/services'
import { parseDate } from 'utils/date'
import { ItineraryForm } from './ItineraryForm'
import { RouteForm } from './RouteForm'

const ITINERARIES_STEP = 3

export const EditRoute = ({ route, services, onSubmit, error, loading }: TSFixMe): ReactElement | null => {
  let content
  const [step, setStep] = useState(1)
  const [newRoute, setNewRoute] = useState<TSFixMe>()
  const [newServices, setNewServices] = useState<IService[]>([])
  const [isReplacingPlaces, setIsReplacingPlaces] = useState<boolean | undefined>()
  const { layout } = useContext(LayoutContext)

  const scrollToTop = (): void => {
    if (layout.appContentEl?.current) {
      layout.appContentEl.current.scrollTop = 0
    }
  }

  switch (step) {
    case 1:
      content = (
        <RouteForm
          route={route}
          services={services}
          isReplacingPlaces={isReplacingPlaces}
          setIsReplacingPlaces={setIsReplacingPlaces}
          onSubmit={({ route, services }: { route: TSFixMe; services: TSFixMe }): TSFixMe => {
            setNewRoute({
              ...route
            })

            setNewServices(
              services.map((service: IChangeRouteServiceRouteForm): IService => {
                const endDate = service.endAt ? parseDate(service.endAt) : undefined

                return {
                  id: service.id,
                  isActive: service.isActive,
                  code: service.code ?? '',
                  startDate: parseDate(service.startAt),
                  endDate,
                  itineraries: [getEmptyItinerary(route.id, route.stops, undefined, endDate)],
                  oldItineraries: service.itinerariesSchedule.map(mapItineraryScheduleToItinerary),
                  vehicles: []
                }
              })
            )
            setStep(2)
          }}
          scrollToTop={scrollToTop}
        />
      )
      break
    case 2:
      content = (
        <SummaryForm
          step={2}
          route={newRoute}
          lines={newRoute.companyLines}
          onCancel={(): TSFixMe => setStep(1)}
          onSubmit={(): TSFixMe => {
            setStep(3)
          }}
          submitLabel={<FormattedMessage id="routes.edit.form.segments.next" defaultMessage="Next" />}
          scrollToTop={scrollToTop}
        />
      )
      break
    case ITINERARIES_STEP:
      content = (
        <ItineraryForm
          services={newServices}
          loading={loading}
          error={error}
          onCancel={(): TSFixMe => setStep(2)}
          onSubmit={({ services }: { services: IService[] }): void => {
            setNewServices([...services])
            onSubmit({
              route: newRoute,
              services,
              isReplacingPlaces
            })
          }}
          scrollToTop={scrollToTop}
        />
      )
  }

  return (
    <>
      <FormLayoutV2.Content isLargeContent={step === ITINERARIES_STEP}>
        <Heading.H3>
          <FormattedMessage id="routes.edit.title" defaultMessage="Change route" />
        </Heading.H3>
        {content}
      </FormLayoutV2.Content>
    </>
  )
}
